// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lineTimetableHeader_header_zGQza {
  display: flex;
  margin-bottom: 1rem;
  word-wrap: break-word;
  break-inside: avoid;
  break-after: avoid;
}

.lineTimetableHeader_lineId_cKDdA {
  font-size: 2rem;
  margin: 2rem 2rem 0 2rem;
  font-family: GothamRounded-Medium;
}

.lineTimetableHeader_nameContainer_ZpekB {
  padding-top: 2rem;
}

.lineTimetableHeader_lineName_ovE6M {
  font-size: 20px;
  font-family: GothamRounded-Medium;
}

.lineTimetableHeader_lineNameSecondary_HIWUr {
  font-size: 20px;
  font-family: GothamRounded-Book;
}
`, "",{"version":3,"sources":["webpack://./src/components/lineTimetable/lineTimetableHeader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".header {\n  display: flex;\n  margin-bottom: 1rem;\n  word-wrap: break-word;\n  break-inside: avoid;\n  break-after: avoid;\n}\n\n.lineId {\n  font-size: 2rem;\n  margin: 2rem 2rem 0 2rem;\n  font-family: GothamRounded-Medium;\n}\n\n.nameContainer {\n  padding-top: 2rem;\n}\n\n.lineName {\n  font-size: 20px;\n  font-family: GothamRounded-Medium;\n}\n\n.lineNameSecondary {\n  font-size: 20px;\n  font-family: GothamRounded-Book;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `lineTimetableHeader_header_zGQza`,
	"lineId": `lineTimetableHeader_lineId_cKDdA`,
	"nameContainer": `lineTimetableHeader_nameContainer_ZpekB`,
	"lineName": `lineTimetableHeader_lineName_ovE6M`,
	"lineNameSecondary": `lineTimetableHeader_lineNameSecondary_HIWUr`
};
module.exports = ___CSS_LOADER_EXPORT___;
